import { Directive, HostListener } from '@angular/core';
import { ScrollService } from '@services/scroll/scroll.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[scrollTracker]'
})
export class ScrollTrackerDirective {

  constructor(private scrollService: ScrollService) {/**/}

  @HostListener('ionScroll', ['$event'])
  onScroll(event: CustomEvent) {
    this.scrollService.currentScrollSubject.next(event);
  }

}
